"use strict";

var chipsUsersTagsCtrl = [
    "$http",
    "Member",
    "Department",
    "$scope",
    "$state",
    "toast",
    function ($http, Member, Department, $scope, $state, toast) {
        var _this = this;
        this.filterList = JSON.parse(JSON.stringify(this.filter || []));

        this.addUserToList = function (item) {
            var _this = this;
            _this.list.push(item);
            _this.filterList.push(item);
            _this.newUser = "";

            // console.log('item', item);
            // console.log('_this.list', _this.list);
            // console.log('_this.filterList', _this.filterList);
        };

        this.removeChip = function (index) {
            var removedUser = _this.list.splice(index, 1);
            _this.filterList = _this.filterList.filter(function (member) {
                return member.id !== removedUser[0].id;
            });
        };

        this.getChipsData = function (query) {
            // console.log('getChipsData query', query)
            return _this.getUsers(query)
            .then(function (users) {
                // console.log('users sin filtrar', users);
                let filteredUsers = users; //.sort((a, b) => (a.lastName ?? '').localeCompare(b.lastName ?? ''));
                let lowerCaseQuery = query?.toLowerCase();
                if (query) { 
                    filteredUsers = users.filter(user => {
                        return (user.firstName?.toLowerCase().includes(lowerCaseQuery) || user.lastName?.toLowerCase().includes(lowerCaseQuery) || user.email?.toLowerCase().includes(lowerCaseQuery) || user.name?.toLowerCase().includes(lowerCaseQuery))
                    })
                    // console.log('filteredUsers', filteredUsers)
                }
                // console.log('getChipsData this.completeList ', _this.completeList)
                _this.filterFromCompleteList();
                return filteredUsers;
            })
            .catch(function (error) {
                console.log(error);
                return [];
            });
        };
        

        this.getUsers = function (query) {
            // console.log('$scope.attr.getFrom', $scope.attr.getFrom)
            if ($scope.attr.getFrom) {
                // console.log('entro en $scope.attr.getFrom')
                return _this
                    .getFrom({ query: query })
                    .then(function (data) {
                        // console.log('$scope.attr.getFrom data', data)
                        return data.filter(function (member) {
                            if (_this.filterList) {
                                for (var i = 0; i < _this.filterList.length; i++) {
                                    if (_this.filterList[i].id === member.id) {
                                        return false;
                                    }
                                }
                            }
                            return member;
                        })
                        // .sort((a, b) => (a.lastName ?? '').localeCompare(b.lastName ?? ''));;
                    });
            }

            // console.log('siguio, query', query);
            var search = { filter: { include: ["clients"] } };
            
            if (query) {
                // console.log('entro en query', query);
                var nameQuery = query.split(" ");
                nameQuery = nameQuery.map(function transformWord(word) {
                    return "(\\b" + word + ")";
                });

                nameQuery = nameQuery.reduce(function reducingQueryToString(
                    query,
                    reg
                ) {
                    if (!query) {
                        return reg;
                    }
                    query = query + "|" + reg;
                    return query;
                },
                    "");

                search = {
                    filter: {
                        include: ["clients"],
                        where: {
                            or: [
                                {
                                    email: {
                                        regexp: "/^" + query + "/gi",
                                    },
                                },
                                {
                                    firstName: {
                                        regexp: "/" + nameQuery + "/gi",
                                    },
                                },
                                {
                                    lastName: {
                                        regexp: "/" + nameQuery + "/gi",
                                    },
                                },
                            ],
                        },
                    },
                };
            }

            // console.log('$state.params.departmentId undefined?', $state.params.departmentId)
            if ($state.params.departmentId == undefined) {
                // console.log('entro en $state.params.departmentId undef')
                return Member.find(search).$promise.then(function (data) {
                    if (_this.filter) {
                        data = data.filter(function (member) {
                            for (var i = 0; i < _this.filterList.length; i++) {
                                if (_this.filterList[i].id === member.id) return false;
                            }
                            return member;
                        });
                    }
                    return data.sort((a, b) => (a.lastName ?? '').localeCompare(b.lastName ?? ''));
                });
            } else {
                // console.log('entro en else $state.params.departmentId');
                return Department.findById({ id: $state.params.departmentId })
                    .$promise.then(function (department) {
                        return Member.find(search)
                        .$promise.then(function (data) {
                            if (_this.filter) {
                                data = data.filter(function (member) {
                                    for (var i = 0; i < _this.filterList.length; i++) {
                                        if (_this.filterList[i].id === member.id) return false;
                                    }
                                    return department == undefined ||
                                        department.clientId == undefined ||
                                        member.clients.length == 0 ||
                                        member.clients.find((clt) => clt.id == department.clientId)
                                        ? member
                                        : false
                                });
                            }
                            return data.sort((a, b) => (a.lastName ?? '').localeCompare(b.lastName ?? ''));
                        });
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        };

        // this.getDepartmentTags = function () {
        //     return Department.tags({ id: $state.params.departmentId })
        //         .$promise.then(function (data) {
        //             return data.filter(function (tag) {
        //                 if (_this.filterList) {
        //                     for (var i = 0; i < _this.filterList.length; i++) {
        //                         if (_this.filterList[i].id === tag.id) {
        //                             return false;
        //                         }
        //                     }
        //                 }
        //                 return tag;
        //             });
        //         })
        //         .catch(function (error) {
        //             console.log(error);
        //             throw new Error(error);
        //         });
        // };

        this.filterFromCompleteList = function() {
            // console.log('filterFromCompleteList completeList', _this.completeList);
            // console.log('filterFromCompleteList list', _this.list);
            if (_this.completeList?.length > 0 && _this.list?.length > 0) {
                _this.list = _this.list.map(item => {
                    const matchingItem = _this.completeList.find(it => it.id === item.id);
                    if (!matchingItem) {
                        // toast.error(`Elemento con id ${item.id} no encontrado en completeList`);
                        console.log(`Elemento con id ${item.id} no encontrado en completeList`);
                    }
                    return matchingItem ? matchingItem : item;
                });
            }
        }
        this.filterFromCompleteList();
        // console.log('this.completeList', this.completeList)
        // console.log('_this.list', _this.list);
        // console.log('getFrom', _this.getFrom)
    },

];

module.exports = function () {
    return {
        restrict: "E",
        scope: {
            list: "=",
            filter: "=",
            getFrom: "&",
            completeList: "=",
        },
        controller: chipsUsersTagsCtrl,
        controllerAs: "ctrl",
        bindToController: true,
        templateUrl: "chips-users-tags-directive/chipsUsersTagsDirective.html",
        link: function (scope, element, attr) {
            scope.attr = attr;
        },
    };
};
